/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Meal_Dinner_DishInputs */

const en_for_whom_meal_dinner_dish = /** @type {(inputs: For_Whom_Meal_Dinner_DishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salmon with grains and salad`)
};

const pl_for_whom_meal_dinner_dish = /** @type {(inputs: For_Whom_Meal_Dinner_DishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Łosoś z kaszą i sałatką`)
};

/**
* | output |
* | --- |
* | "Salmon with grains and salad" |
*
* @param {For_Whom_Meal_Dinner_DishInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_meal_dinner_dish = /** @type {((inputs?: For_Whom_Meal_Dinner_DishInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Meal_Dinner_DishInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_meal_dinner_dish(inputs)
	return en_for_whom_meal_dinner_dish(inputs)
});